// src/hooks/useEsMovil.js
// Detección reactiva de viewport móvil. Reemplaza las copias sueltas de
// `window.matchMedia('(max-width: 768px)')` repartidas por el código.
//
// Uso:
//   const esMovil = useEsMovil();           // breakpoint 768px por defecto
//   const esChico = useEsMovil(480);        // breakpoint custom
import { useState, useEffect } from 'react';

export default function useEsMovil(breakpoint = 768) {
  const query = `(max-width: ${breakpoint}px)`;
  const [esMovil, setEsMovil] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e) => setEsMovil(e.matches);
    mq.addEventListener('change', handler);
    setEsMovil(mq.matches); // sincronizar por si cambió entre el primer render y el efecto
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return esMovil;
}
